const landingLangs = require('../../../enums/landing-languages').enum;

module.exports = {
	// Kyrgyz
	'KG': [landingLangs.ru],
	// Albania
	'AL': [landingLangs.al],
	// Kosovo
	'XK': [landingLangs.al],
	// Georgia
	'GE': [landingLangs.ru, landingLangs.ka],
	// Germany
	'DE': [landingLangs.de, landingLangs.en],
	// Switzerland
	'CH': [landingLangs.de],
	// Nicaragua
	'NI': [landingLangs.es],
	// Costa Rica
	'CR': [landingLangs.es],
	// Greece
	'GR': [landingLangs.el],
	// Kazakhstan
	'KZ': [landingLangs.ru],
	// Portugal
	'PT': [landingLangs.pt, landingLangs.en],
	// Uzbekistan
	'UZ': [landingLangs.ru],
	// Estonia (not matching)
	'EE': [landingLangs.ru, landingLangs.ee, landingLangs.en],
	// Latvia (not matching)
	'LV': [landingLangs.lv, landingLangs.ru, landingLangs.en],
	// Poland
	'PL': [landingLangs.pl, landingLangs.en],
	// Republic of Moldova
	'MD': [landingLangs.ru],
	// Ukraine
	'UA': [landingLangs.ru],
	// France
	'FR': [landingLangs.fr],
	// Romania
	'RO': [landingLangs.ro, landingLangs.en],
	// Spain
	'ES': [landingLangs.es, landingLangs.en],
	// Thailand
	'TH': [landingLangs.th],
	// Panama
	'PA': [landingLangs.es],
	// Republic of Lithuania (not matching)
	'LT': [landingLangs.lt, landingLangs.ru, landingLangs.en],
	// Italy
	'IT': [landingLangs.it, landingLangs.en],
	// Russia
	'RU': [landingLangs.ru],
	// Armenia (not matching)
	'AM': [landingLangs.ru, landingLangs.el],
	// Hungary
	'HU': [landingLangs.hu, landingLangs.en],
	// Cyprus
	'CY': [landingLangs.el],
	// Belarus
	'BY': [landingLangs.ru],
	// Azerbaijan
	'AZ': [landingLangs.az],
	// Bulgaria
	'BG': [landingLangs.bg, landingLangs.en],
	// Slovenia
	'SI': [landingLangs.si, landingLangs.en],
	// Slovak Republic
	'SK': [landingLangs.sk],
	// Czechia
	'CZ': [landingLangs.cz],
	// Austria
	'AT': [landingLangs.de, landingLangs.en],
	// Croatia
	'HR': [landingLangs.hr, landingLangs.en],
	// Netherlands
	'NL': [landingLangs.nl],
	// Belgium
	'BE': [landingLangs.nl, landingLangs.fr],
	// Luxembourg
	'LU': [landingLangs.fr],
	// Singapore
	'SG': [landingLangs.my, landingLangs.en],
	// Congo
	'CD': [landingLangs.fr],
	// South African Republic
	'ZA': [landingLangs.en],
	// Rwanda
	'RW': [landingLangs.en],
	// United Kingdom
	'GB': [landingLangs.en],
	// USA
	'US': [landingLangs.en],
	//Sweden
	'SE': [landingLangs.sv, landingLangs.en],
	//Oman
	'OM': [landingLangs.ar],
	// Canada
	'CA': [landingLangs.en, landingLangs.fr],
	// Argentina
	'AR': [landingLangs.es],
	// Mexico
	'MX': [landingLangs.es],
	//Vietnam
	'VN': [landingLangs.vi],
	//Indonesia
	'ID': [landingLangs.id],
	//Maylay
	'MY': [landingLangs.my],
	//Lebanon
	'LB': [landingLangs.en, landingLangs.fr, landingLangs.ar],
	//United Arab Emirates
	'AE': [landingLangs.en, landingLangs.ar],
	//Saudi arabia
	'SA': [landingLangs.ar],
	//Chile
	'CL': [landingLangs.es],
	//Columbia
	'CO': [landingLangs.es],
	//India
	'IN': [landingLangs.hi],
	//Bangladesh
	'BD': [landingLangs.bn],
	//Taiwan
	'TW': [landingLangs.zh],
	//Burma
	'MM': [landingLangs.bu],
	//Philippines
	'PH': [landingLangs.tl],
	//Sri Lanka
	'LK': [landingLangs.ta, landingLangs.sg],
	//Kuwait
	'KW': [landingLangs.ar],
	//Nigeria
	'NG': [landingLangs.en],
	//Jordan
	'JO': [landingLangs.ar],
	//Bahrain
	'BH': [landingLangs.ar],
	//Turkey
	'TR': [landingLangs.tr],

	'BR': [landingLangs.pt],
	'GT': [landingLangs.es],
	'HN': [landingLangs.es],
	'SV': [landingLangs.es],
	'BO': [landingLangs.es],
	'PE': [landingLangs.es],
	'IQ': [landingLangs.ar],
	'QA': [landingLangs.ar, landingLangs.en],
	'EC': [landingLangs.es]
};



// WEBPACK FOOTER //
// ./frontend/shared/js/geo_landing_lang_relations.js